<script setup lang="ts">
import type { AssessmentItem } from '@/presentlevels/api_v2.ts'

defineProps<{
  item: AssessmentItem
}>()

const emit = defineEmits<{
  'toggle': [item: AssessmentItem]
}>()

function handleToggle(item: AssessmentItem) {
  emit('toggle', item)
}
</script>

<template>
  <div
    role="button"
    tabindex="0"
    :aria-pressed="item.selected"
    class="rounded-lg p-3 mb-2 cursor-pointer relative transition-all select-none"
    :class="[
      item.selected ? 'border-[1.5px] border-[#558b2f] bg-[#f1f8e9]' : 'border-[1.5px] border-gray-200 bg-white'
    ]"
    @click="handleToggle(item)"
    @keydown.enter="handleToggle(item)"
    @keydown.space.prevent="handleToggle(item)"
  >
    <div class="flex gap-2.5 items-start">
      <!-- Custom checkbox -->
      <div
        class="w-[17px] h-[17px] flex-shrink-0 mt-0.5 rounded-md flex items-center justify-center transition-colors"
        :class="[
          item.selected ? 'bg-[#1565c0] border-[1.5px] border-[#1565c0]' : 'bg-white border-[1.5px] border-gray-500'
        ]"
      >
        <svg v-if="item.selected" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="20 6 9 17 4 12"/>
        </svg>
      </div>
      <!-- Content -->
      <div class="flex-1 min-w-0">
        <div class="font-semibold text-lg text-gray-900 mb-0.5">{{ item.title }}</div>
        <div v-if="item.description" class="text-md text-gray-700 mb-1">{{ item.description }}</div>
        <div v-if="item.dataRef" class="text-md text-[#1565c0] italic">{{ item.dataRef }}</div>
      </div>
      <!-- Green checkmark badge when selected -->
      <div v-if="item.selected" class="flex-shrink-0">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2e7d32" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="20 6 9 17 4 12"/>
        </svg>
      </div>
    </div>
  </div>
</template>
